import React, { useEffect, useMemo, useState } from 'react';
import { UsuariosAdapter } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { PERFIL_ADMIN } from '../../../../../shared/constanst/constants';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { useUserSettings } from '../../../context/CurrentUserContext';
import Formulario from './formulario';

export const FormularioUsuarios = (props: any) => {

	const { currentUser, handle, selected, onClose, translate } = props;
	const api = new UsuariosAdapter();
	const {resultError, exceptionError}  = useNotifications();
	let [permisosUser, setPermisosUser] = useState<any>(undefined);

	const havePermissions = useMemo(()=> currentUser.perfil!==PERFIL_ADMIN ,[currentUser])

	useEffect(()=>{
		if(havePermissions===true)
			getPermissionsUser(currentUser);
	},[])

	const getPermissionsUser = async (user:any) => {
		try {
			let resultPermisos:any = await api.GetPermisosUsuario(user.dni);
			if(resultPermisos.data && resultPermisos.data!=="")
			{
				setPermisosUser(resultPermisos.data);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};
	
	return ((havePermissions === true && permisosUser!==undefined) || !havePermissions) ? 
	<Formulario onSave={handle} permisosUser={permisosUser} currentUser={currentUser} selected={selected} onClose={onClose} translate={translate}/> 
	: null;
};

export default FormularioUsuarios;